import Input from "@Components/Input";
import styles from "./DatePickerDropdown.module.scss";
import DatePickerWrapper from "@Components/DatePicker/DatePickerWrapper";
import {
  getMaxDateObject,
  getMinDateObject,
  getObjectFromDate,
} from "@Components/DatePicker/helper";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";
import { SCREEN_SIZE, useResponsiveness } from "hooks/useResponsiveness";

const DatePickerDropdown = ({
  value,
  label,
  placeholder,
  onFocus,
  error,
  handleClear,
  isCalendarOpened,
  handleSelectDate,
  hideDatePicker,
  disabled,
  type = "text",
  maxYearLimit = -1,
  minYearLimit = 1,
  required = false,
  clearable = true,
  dataTestId = "",
  ...props
}: any) => {
  const { isAbove } = useResponsiveness();
  const isAboveMD = isAbove(SCREEN_SIZE.MD, false);
  const { month, day, year } =
    props.day && props.month && props.year ? props : getObjectFromDate(new Date());
  const { year: maxYear } = getMaxDateObject(1, 0, maxYearLimit);
  const { year: minYear } = getMinDateObject(1, 0, minYearLimit);
  const { t } = useTranslationHook();

  return (
    <div className={styles.moveInSection}>
      <Input
        dataTestId={dataTestId}
        type={type}
        label={t(label)}
        placeholder={placeholder}
        value={value}
        onFocus={onFocus}
        showErrorMessage={Boolean(error)}
        clearable={clearable}
        handleClear={handleClear}
        error={error}
        required={required}
        readOnly
        disabled={disabled}
        rightIcon={props.rightIcon}
        showPlaceholderAndLabel={props.showPlaceholderAndLabel}
      />
      {isCalendarOpened && (
        <DatePickerWrapper
          minYear={minYear}
          maxYear={maxYear}
          day={day}
          month={props.month ? month - 1 : month}
          year={year}
          handleSelectDate={handleSelectDate}
          openInBottom
          hideDatePicker={hideDatePicker}
          isAboveMD={isAboveMD}
          type="large"
        />
      )}
    </div>
  );
};

export default wrapperHOC(DatePickerDropdown, {
  componentName: "DatePickerDropdown-BookForm",
  showForChina: true,
});
